export default "__VITE_ASSET__63627e1c__"